export const EMPTY_FIELD_MESSAGE = 'Для данного типа документов нет настроек для скачивания XML';
